/* Craftmate Diwali Sale page: carousel + countdown web components.
   Custom elements re-initialise on their own when the theme editor reloads a section. */
(function () {
  var IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;
  var DAY_MS = 24 * 60 * 60 * 1000;

  if (!customElements.get('dw-carousel')) {
    class DwCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dw-track');
        if (!this.track) return;
        this.prev = this.querySelector('[data-dw-prev]');
        this.next = this.querySelector('[data-dw-next]');
        this.dotsWrap = this.querySelector('.dw-dots');
        this.onScroll = this.update.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
        if (this.next) this.next.addEventListener('click', () => this.step(1));
        this.buildDots();
        this.update();
        var autoplay = parseInt(this.dataset.autoplay || '0', 10);
        if (autoplay > 0) this.startAutoplay(autoplay * 1000);
      }
      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        clearInterval(this.timer);
      }
      items() { return Array.from(this.track.children); }
      step(dir) {
        var first = this.items()[0];
        var itemW = first ? first.getBoundingClientRect().width : this.track.clientWidth;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        var perView = Math.max(1, Math.floor((this.track.clientWidth + gap) / (itemW + gap)));
        var max = this.track.scrollWidth - this.track.clientWidth;
        var target = this.track.scrollLeft + dir * perView * (itemW + gap);
        if (this.dataset.loop === 'true') {
          if (dir > 0 && this.track.scrollLeft >= max - 4) target = 0;
          if (dir < 0 && this.track.scrollLeft <= 4) target = max;
        }
        this.track.scrollTo({ left: target, behavior: 'smooth' });
      }
      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';
        this.items().forEach((item, i) => {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'dw-dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => this.track.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: 'smooth' }));
          this.dotsWrap.appendChild(b);
        });
      }
      update() {
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.dataset.scrollable = max > 4 ? 'true' : 'false';
        if (this.dataset.loop !== 'true') {
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
          if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4;
        }
        if (this.dotsWrap) {
          var idx = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
          Array.from(this.dotsWrap.children).forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        }
      }
      startAutoplay(ms) {
        var paused = false;
        this.addEventListener('mouseenter', () => (paused = true));
        this.addEventListener('mouseleave', () => (paused = false));
        this.addEventListener('touchstart', () => (paused = true), { passive: true });
        if (window.Shopify && Shopify.designMode) return;
        this.timer = setInterval(() => {
          if (paused || document.hidden) return;
          var max = this.track.scrollWidth - this.track.clientWidth;
          if (this.track.scrollLeft >= max - 4) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.step(1);
        }, ms);
      }
    }
    customElements.define('dw-carousel', DwCarousel);
  }

  if (!customElements.get('dw-countdown')) {
    class DwCountdown extends HTMLElement {
      connectedCallback() {
        this.els = {
          d: this.querySelector('[data-dw-d]'),
          h: this.querySelector('[data-dw-h]'),
          m: this.querySelector('[data-dw-m]'),
          s: this.querySelector('[data-dw-s]')
        };
        this.end = this.computeEnd();
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      computeEnd() {
        if (this.dataset.mode === 'daily') {
          var nowIst = Date.now() + IST_OFFSET_MS;
          return (Math.floor(nowIst / DAY_MS) + 1) * DAY_MS - IST_OFFSET_MS;
        }
        var date = (this.dataset.date || '').trim();
        var time = (this.dataset.time || '23:59').trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
        if (!/^\d{1,2}:\d{2}$/.test(time)) time = '23:59';
        if (time.length === 4) time = '0' + time;
        var t = Date.parse(date + 'T' + time + ':00+05:30');
        return isNaN(t) ? null : t;
      }
      pad(n) { return n < 10 ? '0' + n : String(n); }
      tick() {
        if (this.end === null) { this.dataset.done = 'false'; return; }
        var diff = this.end - Date.now();
        if (diff <= 0) {
          if (this.dataset.mode === 'daily') { this.end = this.computeEnd(); return; }
          clearInterval(this.timer);
          this.dataset.done = 'true';
          if (this.dataset.expired === 'hide' && !(window.Shopify && Shopify.designMode)) {
            var section = this.closest('[data-dw-hide-on-expire]');
            if (section) section.style.display = 'none';
          }
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        if (this.els.d) this.els.d.textContent = this.pad(d);
        if (this.els.h) this.els.h.textContent = this.pad(h);
        if (this.els.m) this.els.m.textContent = this.pad(m);
        if (this.els.s) this.els.s.textContent = this.pad(s % 60);
      }
    }
    customElements.define('dw-countdown', DwCountdown);
  }

  /* Click-to-play for Shopify-hosted video and YouTube/Vimeo embeds */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dw-play]');
    if (!btn) return;
    var frame = btn.closest('.dw-video__frame');
    var tpl = frame && frame.querySelector('template');
    if (tpl) {
      frame.querySelectorAll('img').forEach(function (img) { img.remove(); });
      frame.appendChild(tpl.content.cloneNode(true));
      var v = frame.querySelector('video');
      if (v) v.play();
    }
    btn.remove();
  });
})();